import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import { AddToCartButton } from '../../button/add-to-cart';
import { ProductColorSwatch } from '../color-swatch';
import { useScreen } from '../../../hooks/useScreen';
import { useMemo } from 'react';
import { NewSelect } from '../../select/new-select';
import { Button } from '../../button';
import { HelperText } from '../bed-generator/helper-text';
import { PRODUCTS_PAGE } from '../../../constants/global';
import BreadPayPlacement from '../../breadpay/placement';
import { NonBedPdpContext } from '../../template/product/detail/pdp-context';
/**
 * @description Render memoized add to cart component
 * @param {Object} props
 * @returns {JSX.Element} Memoized add to cart component
 */
export const ProductAddToCart = ({ product, setCurrentVariant }) => {
  const [selectedColor, setSelectedColor] = useState('');
  const [selectedOption, setSelectedOption] = useState([]);
  const [selectedQuantity, setQuantity] = useState(1);
  const { setMainPdpItemQuantity } = useContext(NonBedPdpContext);
  const { isMobile } = useScreen();

  let options = [];
  let minPrice = -1;

  product?.options?.forEach((item) => {
    const option = { name: item.display_name, option_id: item.id, values: [...item.option_values], type: item.type };
    if (item.display_name.includes('COLOR') || item.display_name.includes('Color')) {
      options.unshift(option);
    } else {
      options.push(option);
    }
  });

  const onSelectOption = (option_id, id) => {
    try {
      let options = [...selectedOption];
      let pos = options.findIndex((item, i) => {
        return item.option_id === option_id;
      });
      if (pos >= 0) {
        options[pos] = { id, option_id };
      } else options.push({ id, option_id });
      options.sort((a, b) => a.option_id - b.option_id);
      setSelectedOption([...options]);
    } catch (error) {
      return;
    }
  };

  useEffect(() => {
    setCurrentVariant(getSelectedVariant());
  }, [selectedOption]);

  const getSelectedVariant = () => {
    let currentVariant = null;
    const variants =
      product?.variants?.filter((item) => {
        const sortedVariant = item?.option_values?.sort((a, b) => a.option_id - b.option_id);
        return JSON.stringify(sortedVariant) === JSON.stringify(selectedOption);
      }) || null;
    if (variants?.length !== 0) {
      currentVariant = variants?.[0] || null;
    } else {
      currentVariant = null;
    }
    return currentVariant;
  };

  product?.custom_fields?.forEach((item) => {
    if (item.name.toLowerCase().includes('min')) {
      minPrice = item.value;
    }
  });
  const HelperTextPreOrderContainer = ({ children }) => {
    return <div className="mb-3 flex justify-center text-sm text-[#d53535]">{children}</div>;
  };

  const checkAvailibility = () => {
    const itemNotAvailable = product?.availability != 'available';
    const variantNotAvailable =
      product?.inventory_tracking === 'variant' &&
      (getSelectedVariant()?.inventory_level === 0 ||
        getSelectedVariant()?.inventory_level < selectedQuantity ||
        getSelectedVariant()?.purchasing_disabled === true ||
        options.length !== selectedOption?.length);

    const isAddToCartDisabled =
      product?.availability === 'disabled' || (product?.inventory_tracking === 'variant' && variantNotAvailable);

    return { itemNotAvailable, variantNotAvailable, isAddToCartDisabled };
  };

  const colorOption = useMemo(() => {
    return options.find((item) => item.option_id && item?.type === 'swatch');
  }, [options]);

  const addToCartButtonText = () => {
    if (product?.availability === 'available') {
      return 'Add to cart';
    } else if (product?.availability === 'preorder') {
      return 'Pre-Order';
    }
  };
  const ErrorBlock = () => {
    if (selectedOption?.length > 0 && checkAvailibility().variantNotAvailable) {
      return (
        <HelperTextPreOrderContainer>*The selected combination is currently unavailable.</HelperTextPreOrderContainer>
      );
    } else if (checkAvailibility().itemNotAvailable) {
      return (
        <HelperTextPreOrderContainer>
          <HelperText product={product} />
        </HelperTextPreOrderContainer>
      );
    }
  };

  const dropdownOptions = useMemo(() => options.filter((item) => item.option_id && item?.type !== 'swatch'), [options]);

  const calculatePrice = useMemo(() => {
    let price;
    if (getSelectedVariant()) {
      price = getSelectedVariant().calculated_price.toLocaleString(undefined, { minimumFractionDigits: 2 });
    } else {
      if (minPrice >= 0) {
        price = minPrice.toLocaleString(undefined, { minimumFractionDigits: 2 });
      } else {
        price = product?.calculated_price?.toLocaleString(undefined, { minimumFractionDigits: 2 });
      }
    }
    return price;
  }, [minPrice, getSelectedVariant(), product]);

  useEffect(() => {
    setMainPdpItemQuantity(selectedQuantity);
  }, [selectedQuantity]);

  return (
    <div className={`${isMobile ? 'pt-10' : 'py-10'}`}>
      <div className="relative">
        {selectedOption.length === options.length &&
          (product?.availability === 'preorder' || product?.availability === 'available') && <ErrorBlock />}
        <div className="product-add-to-cart flex flex-col justify-between gap-x-3 md:flex-row md:items-start">
          <div className="product-add-to-cart-text-block mb-4 w-full">
            <p className="product-add-to-cart-title m-0">{product?.name}</p>
            <p className="product-add-to-cart-price m-0">${calculatePrice}</p>
            {/* {checkAvailibility().itemNotAvailable && !checkAvailibility().variantNotAvailable ? (
              <HelperTextContainer>
                <HelperText product={product} />
              </HelperTextContainer>
            ) : (
              <>
                {checkAvailibility().variantNotAvailable && (
                  <HelperTextContainer>*The selected combination is currently unavailable.</HelperTextContainer>
                )}
              </>
            )} */}
            {/* {product?.availability != 'available' ? (
              <p className="text-not-available">*The product is not available to purchase in online store.</p>
            ) : (
              <>
                {(getSelectedVariant()?.inventory_level === 0 ||
                  getSelectedVariant()?.purchasing_disabled === true ||
                  true) && <p className="text-not-available">*The selected combination is currently unavailable.</p>}
              </>
            )} */}
          </div>
          {isMobile && colorOption && (
            <div className="flex items-center justify-between" key={colorOption.id}>
              {selectedColor ? (
                <p className="product-add-to-cart-color flex !w-auto items-center text-xs font-normal leading-5">
                  Color:&nbsp;
                  <span className="lowercase text-black first-letter:!uppercase">
                    {colorOption?.values?.find((value) => value.id === selectedColor)?.label}
                  </span>
                </p>
              ) : (
                <span className="lead block text-xs lowercase leading-5 first-letter:!uppercase">
                  SELECT {colorOption.name}
                </span>
              )}
              <ProductColorSwatch
                handleChange={(id) => {
                  setSelectedColor(id);
                  onSelectOption(colorOption.option_id, id);
                }}
                selected={selectedColor}
                colors={colorOption?.values}
                options={options}
                product={product}
                selectedOption={selectedOption}
              />
            </div>
          )}
          {product?.availability !== 'disabled' ? (
            <div className="product-add-to-cart-options-block min-w-[148px] flex-col flex-wrap !gap-y-0 gap-x-3 md:-mt-1.5 md:flex md:flex-row">
              {colorOption && !isMobile && (
                <div key={colorOption.id}>
                  {selectedColor ? (
                    <p className="product-add-to-cart-color m-0 flex !w-auto items-baseline text-xs font-normal leading-5 ">
                      Color:&nbsp;
                      <span className="min-w-[110px] lowercase text-black first-letter:!uppercase">
                        {colorOption?.values?.find((value) => value.id === selectedColor)?.label}
                      </span>
                    </p>
                  ) : (
                    <span className="block text-xs lowercase leading-5 first-letter:!uppercase">
                      SELECT {colorOption.name}
                    </span>
                  )}
                  <ProductColorSwatch
                    handleChange={(id) => {
                      setSelectedColor(id);
                      onSelectOption(colorOption.option_id, id);
                    }}
                    selected={selectedColor}
                    colors={colorOption?.values}
                    options={options}
                    product={product}
                    selectedOption={selectedOption}
                  />
                  {/* <Link to="/shops" className="product-add-to-cart-link flex items-center text-xs md:text-sm">
                    <span className="btn btn--secondary !mt-0 text-[11px]">Custom made</span>
                  </Link> */}
                </div>
              )}
            </div>
          ) : !isMobile ? (
            <div className="product-add-to-cart-options-block flex flex-1 flex-col flex-wrap md:flex-row md:justify-center">
              <ErrorBlock />
            </div>
          ) : (
            <></>
          )}
          <div className="flex-1 gap-x-3 lg:flex">
            {product?.availability !== 'disabled' ? (
              <div className="product-add-to-cart-options-block flex-1">
                <div className="grid flex-1 grid-cols-2 flex-col flex-wrap !gap-y-0 gap-x-3 md:flex md:flex-row">
                  {dropdownOptions?.length > 0 &&
                    dropdownOptions?.map((item, index) => {
                      return (
                        item?.option_id && (
                          <div key={index} className="product-add-to-cart-option">
                            <NewSelect
                              className="w-full"
                              name={item.name}
                              // initial={'SELECT ' + item.name}
                              options={item?.values}
                              handleChange={({ value: id }) => {
                                onSelectOption(item.option_id, Number(id));
                              }}
                            />
                          </div>
                        )
                      );
                    })}
                  {isMobile && !!(dropdownOptions?.length % 2) && (
                    <NewSelect
                      className="bed-option product-add-to-cart-quantity flex-1"
                      name="quantity"
                      options={[...Array(10).keys()]}
                      selected={selectedQuantity}
                      handleChange={({ value }) => {
                        setQuantity(value);
                      }}
                    />
                  )}
                </div>
              </div>
            ) : isMobile ? (
              <div className="product-add-to-cart-options-block flex flex-1 flex-col flex-wrap md:flex-row md:justify-center">
                <ErrorBlock />
              </div>
            ) : (
              <></>
            )}
            {isMobile ? (
              <>
                {product?.availability === 'disabled' ? (
                  <div className="product-add-to-cart-button-block w-96">
                    <div className="product-add-to-cart-button w-full md:mt-0">
                      <Button
                        label="Product Questions?"
                        className="mb-4 inline-flex h-12 w-full items-center justify-center border border-black bg-white text-base text-black"
                        redirectUrl="/about-us/contact-us"
                      />
                    </div>

                    <div className="product-add-to-cart-button w-full md:mt-0">
                      <Button
                        label="Find a store"
                        className="mb-4 inline-flex h-12 w-full items-center justify-center bg-black text-base text-white"
                        redirectUrl="/stores/"
                      />
                    </div>
                  </div>
                ) : (
                  <>
                    {!(dropdownOptions?.length % 2) ? (
                      <div className="product-add-to-cart-button-block grid grid-cols-2 flex-col flex-wrap !gap-y-0 gap-x-3">
                        <NewSelect
                          name="quantity"
                          options={[...Array(10).keys()]}
                          selected={selectedQuantity}
                          handleChange={({ value }) => {
                            setQuantity(value);
                          }}
                        />

                        <div className="product-add-to-cart-button w-full flex-1 md:mt-0 md:w-48">
                          <AddToCartButton
                            disabled={checkAvailibility().isAddToCartDisabled}
                            className="mb-4 inline-flex h-12 w-full items-center justify-center border border-[#7E7E7E] bg-black text-sm text-white"
                            variant={getSelectedVariant()}
                            options={selectedOption}
                            quantity={selectedQuantity}
                          >
                            {addToCartButtonText()}
                          </AddToCartButton>
                          <BreadPayPlacement type={PRODUCTS_PAGE} />
                        </div>
                      </div>
                    ) : (
                      <div className="product-add-to-cart-button w-full md:mt-0 md:w-48 ">
                        <AddToCartButton
                          disabled={checkAvailibility().isAddToCartDisabled}
                          className="mb-4 inline-flex h-12 w-full items-center justify-center border border-[#7E7E7E] bg-black text-sm text-white"
                          variant={getSelectedVariant()}
                          options={selectedOption}
                          quantity={selectedQuantity}
                        >
                          {addToCartButtonText()}
                        </AddToCartButton>
                        <BreadPayPlacement type={PRODUCTS_PAGE} />
                      </div>
                    )}
                  </>
                )}
              </>
            ) : (
              <>
                {product?.availability === 'disabled' ? (
                  <div className="product-add-to-cart-button-block w-96">
                    <div className="product-add-to-cart-button w-full md:mt-0">
                      <Button
                        label="Product Questions?"
                        className="mb-4 inline-flex h-12 w-full items-center justify-center border border-black bg-white text-base text-black"
                        redirectUrl="/about-us/contact-us"
                      />
                    </div>

                    <div className="product-add-to-cart-button w-full md:mt-0">
                      <Button
                        label="Find a store"
                        className="mb-4 inline-flex h-12 w-full items-center justify-center border border-[#7E7E7E] bg-black text-sm text-white"
                        redirectUrl="/stores/"
                      />
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="grid grid-cols-2 gap-x-3 lg:flex">
                      <NewSelect
                        className="bed-option product-add-to-cart-quantity md-width-auto w-full"
                        name="quantity"
                        options={[...Array(10).keys()]}
                        selected={selectedQuantity}
                        handleChange={({ value }) => {
                          setQuantity(value);
                        }}
                      />
                      <div className="product-add-to-cart-button ml-0 mt-11 w-full md:mt-0 lg:w-48">
                        <AddToCartButton
                          disabled={checkAvailibility().isAddToCartDisabled}
                          className="mb-4 inline-flex h-12 w-full items-center justify-center border border-[#7E7E7E] bg-black text-sm text-white"
                          variant={getSelectedVariant()}
                          options={selectedOption}
                          quantity={selectedQuantity}
                        >
                          {addToCartButtonText()}
                        </AddToCartButton>
                        <BreadPayPlacement type={PRODUCTS_PAGE} />
                        {/* <BreadPaymentsButton product={product} /> */}
                      </div>
                    </div>
                  </>
                )}
              </>
            )}
            {/* {isMobile && (
            <Link to="/shops" className="product-add-to-cart-link !mt-0 flex items-center text-xs md:text-sm">
              <span className="btn btn--secondary !mt-0 text-[11px]">Custom made</span>
            </Link>
          )} */}
          </div>
        </div>
      </div>
    </div>
  );
};

ProductAddToCart.propTypes = {
  product: PropTypes.shape({
    availability: PropTypes.string,
    calculated_price: PropTypes.any,
    name: PropTypes.string,
    options: PropTypes.array,
    variants: PropTypes.array
  }),
  setCurrentVariant: PropTypes.any
};

export default ProductAddToCart;
